module.exports = __webpack_public_path__ + "static/media/fin_manage8.746f02f5.png";